import {
    TOGGLE_BARCODE_SCANNER,
    TOGGLE_BARCODE_SCANNER_SECONDARY,
    TOGGLE_BARCODE_RESULTS,
    SET_SCANNER_RESULT,
    SET_BARCODE_DATA,
    RESET_BARCODE_DATA,
    SET_FAILED_STATUS
} from '../actions/types';

const initialState = {
	showScanner: false,
	showScannerSecond: false,
	showBarcodeResults: false,
	failedStatus: false,
	scannedBarcode: ''
};
export default (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
		case TOGGLE_BARCODE_SCANNER: {
			return {
				...state,
				showScanner: payload.showScanner
			}
		}
		case TOGGLE_BARCODE_SCANNER_SECONDARY: {
			if(payload.showScannerSecond){
				return {
					...initialState,
					...action.payload
				}
			} else {
				return {
					...state,
					...action.payload
				}
			}
		}
		case TOGGLE_BARCODE_RESULTS: {
			return {
				...state,
				showBarcodeResults: payload.showBarcodeResults
			}
		}
		case SET_SCANNER_RESULT: {
			return {
				...state,
				scannedBarcode: payload.barcodeResult
			}
		}
		case SET_FAILED_STATUS: {
			return {
				...state,
				failedStatus: payload.failedStatus
			}
		}


		case SET_BARCODE_DATA: {
			return {
				showScannerSecond: false,
				...action.payload
			}
		}

		case RESET_BARCODE_DATA: {
			return initialState
		}
	}
	return state;
};
